var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0647 4.95794C18.3902 5.28338 18.3902 5.81102 18.0647 6.13646L8.04738 16.1538L2.74408 10.8505C2.41864 10.5251 2.41864 9.99743 2.74408 9.67199C3.06951 9.34655 3.59715 9.34655 3.92259 9.67199L8.04738 13.7968L16.8862 4.95794C17.2116 4.63251 17.7393 4.63251 18.0647 4.95794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconWhite);
export default __webpack_public_path__ + "static/media/Check-Icon-white.b1c491de596964d713daaa7f908462be.svg";
export { ForwardRef as ReactComponent };